const constants = require('./constants/deployment.js');

const changeFavicon = function(theme, icon = '') {
	const oldLinks = document.querySelectorAll('link[rel*="icon"]');
	const platform = document.querySelector("meta[name='ss:platform']").getAttribute("content");

	// Remove all existing favicons to ensure all browsers update to the new favicon
	[].forEach.call(oldLinks, function (oldLink) {
		document.head.removeChild(oldLink);
	});

	const link = document.createElement('link');

	link.rel = 'shortcut icon';
	link.href = `themes/${theme}/img/${platform}/favicons/favicon${icon && '-' + icon}.png`;
	link.type = 'image/png';

	document.head.appendChild(link);
};

module.exports = {
	updateFavicon: function(theme, deployState) {
		let icon;

		// Do nothing if we can't discern the theme
		if (!theme) {
			return;
		}

		switch (deployState) {
			case constants.STATE_COMPLETED:
				icon = 'deploy-complete';
				break;

			case constants.STATE_FAILED:
				icon = 'deploy-error';
				break;

			default:
				icon = '';
		}

		changeFavicon(theme, icon);
	}
};
